import { useEffect, useState, useRef } from "react";
import axios from "axios";
import config from "../config";
import { notify } from "react-notify-toast";

export default function GoldPayment({
    stepperStateValue,
    packageDetails,
    submitPackageAndFile,
}) {
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [file, setFile] = useState(null);
    const fileUpload = useRef(null);
    const [fileName, setFileName] = useState("");
    const [steps, setSteps] = useState(1);

    function onFormSubmit() {
        if (!file || !selectedPackage) {
            notify.show(
                <div className="bg-red-500 text-white px-4 border rounded-md">
                    Please select Package & file!
                </div>
            );
        } else {
            console.log(file);
            submitPackageAndFile({
                file: file,
                amount: selectedPackage.amount,
                packageId: selectedPackage.packageId,
            });
        }
    }

    return (
        <div className="bg-white border-2 shadow-lg rounded-xl mt-8">
            <div className="border-b-2 flex flex-col-reverse mt-4 lg:mt-0 lg:flex-row justify-between lg:items-center">
                <div className="flex items-center py-4 px-12">
                    <p
                        className={
                            steps == 1
                                ? "border-2 rounded-full px-3 py-1 border-blue-400"
                                : "border-2 rounded-full px-3 py-1 bg-blue-500 text-white"
                        }
                    >
                        {steps == 1 ? "Choose a plan" : 1}
                    </p>
                    <div className="w-8 border-t-2 border-dashed h-px"></div>
                    <p
                        className={
                            steps == 2
                                ? "border-2 rounded-full px-3 py-1 border-blue-400"
                                : steps < 2
                                ? "border-2 rounded-full px-3 py-1 border-grey"
                                : "border-2 rounded-full px-3 py-1 bg-blue-500 text-white"
                        }
                    >
                        {steps == 2 ? "Upload Details" : 2}
                    </p>
                    <div className="w-8 border-t-2 border-dashed h-px"></div>
                    <p
                        className={
                            steps == 3
                                ? "border-2 rounded-full px-3 py-1 border-blue-400"
                                : steps < 3
                                ? "border-2 rounded-full px-3 py-1 border-grey"
                                : "border-2 rounded-full px-3 py-1 bg-blue-500 text-white"
                        }
                    >
                        {steps == 3 ? "Make Payment" : 3}
                    </p>
                </div>
                <button
                        className="btn-primary shadow-lg px-8 mx-12 h-12 w-44"
                        onClick={() => stepperStateValue(0)}
                ><div className="arrow left mr-5"></div>Go Back</button>
            </div>
            <p className="mx-12 my-5 text-xl font-bold">Choose a plan</p>
            <div className="bg-darkblue px-8 shadow-lg rounded-3xl pb-10 mx-10 mb-10">
                <p className="text-white pt-8 text-2xl">Simple & Transparent Pricing Plans</p>
                <div className="flex flex-wrap justify-between space-y-10 lg:space-y-0 pt-10">
                    <div className="bg-card-gradient px-6 py-4 w-full lg:w-5/12 rounded-3xl">
                        <div className="flex justify-between">
                            <div className="flex space-x-2">
                                <input
                                    type="radio"
                                    name="goldPlan"
                                    className="w-5 h-5"
                                    onClick={() => {
                                            setSelectedPackage({
                                                packageId:
                                                    packageDetails["12"].packageId,
                                                amount: packageDetails["12"].amount,
                                            });
                                            if(steps == 1){
                                                setSteps(2)
                                            }
                                        }
                                    }
                                />
                                <p className="text-white">1 Year</p>
                            </div>
                            <p className="text-white">
                                ₹ {packageDetails["12"].amount + 100}/-
                            </p>
                        </div>
                        <div className="flex justify-between mt-4">
                            <p className="bg-coupon py-1 px-2 text-xs text-white">
                                Rs.100 Off : SMEGOLD20
                            </p>
                            <p className="text-white">-100/-</p>
                        </div>
                        <div className="flex justify-between mt-4">
                            <p className="text-white">Net Payable</p>
                            <p className="text-white">
                                ₹ {packageDetails["12"].amount}/-
                            </p>
                        </div>
                    </div>
                    <div className="bg-white w-full lg:w-5/12 px-6 py-4 rounded-3xl">
                        <div className="flex justify-between">
                            <div className="flex space-x-2">
                                <input
                                    type="radio"
                                    name="goldPlan"
                                    className="w-5 h-5"
                                    onClick={() =>{
                                            setSelectedPackage({
                                                packageId:
                                                    packageDetails["6"].packageId,
                                                amount: packageDetails["6"].amount,
                                            });
                                            if(steps == 1){
                                                setSteps(2)
                                            }
                                        }
                                    }
                                />
                                <p>6 Months</p>
                            </div>
                            <p>₹ {packageDetails["6"].amount + 100}/-</p>
                        </div>
                        <div className="flex justify-between mt-4">
                            <p className="py-1 px-2 text-xs bg-gray-100 rounded-2xl">
                                Rs.100 Off : SMEGOLD20
                            </p>
                            <p>-100/-</p>
                        </div>
                        <div className="flex justify-between mt-4">
                            <p>Net Payable</p>
                            <p>₹ {packageDetails["6"].amount}/-</p>
                        </div>
                    </div>
                </div>
                <div className="flex flex-wrap justify-between space-y-10 lg:space-y-0 pt-10">
                    <div className="bg-white w-full lg:w-5/12 px-6 py-4 rounded-3xl">
                        <div className="flex justify-between">
                            <div className="flex space-x-2">
                                <input
                                    type="radio"
                                    name="goldPlan"
                                    className="w-5 h-5"
                                    onClick={() => {
                                            setSelectedPackage({
                                                packageId:
                                                    packageDetails["3"].packageId,
                                                amount: packageDetails["3"].amount,
                                            });
                                            if(steps == 1){
                                                setSteps(2)
                                            }
                                        }
                                    }
                                />
                                <p>3 Months</p>
                            </div>
                            <p>
                                ₹ {packageDetails["3"].amount + 100}/-
                            </p>
                        </div>
                        <div className="flex justify-between mt-4">
                            <p className="py-1 px-2 text-xs bg-gray-100 rounded-2xl">
                                Rs.100 Off : SMEGOLD20
                            </p>
                            <p>-100/-</p>
                        </div>
                        <div className="flex justify-between mt-4">
                            <p>Net Payable</p>
                            <p>₹ {packageDetails["3"].amount}/-</p>
                        </div>
                    </div>
                    <div className="bg-white w-full lg:w-5/12 px-6 py-4 rounded-3xl">
                        <div className="flex justify-between">
                            <div className="flex space-x-2">
                                <input
                                    type="radio"
                                    name="goldPlan"
                                    className="w-5 h-5"
                                    onClick={() => {
                                            setSelectedPackage({
                                                packageId:
                                                    packageDetails["1"].packageId,
                                                amount: packageDetails["1"].amount,
                                            })
                                            if(steps == 1){
                                                setSteps(2)
                                            }
                                        }
                                    }
                                />
                                <p>1 Month</p>
                            </div>
                            <p>₹ {packageDetails["1"].amount + 100}/-</p>
                        </div>
                        <div className="flex justify-between mt-4">
                            <p className="py-1 px-2 text-xs bg-gray-100 rounded-2xl">
                                Rs.100 Off : SMEGOLD20
                            </p>
                            <p>-100/-</p>
                        </div>
                        <div className="flex justify-between mt-4">
                            <p>Net Payable</p>
                            <p>₹ {packageDetails["1"].amount}/-</p>
                        </div>
                    </div>
                </div>
            </div>
            {steps >= 2 && (
                <div className="mx-12 my-10">
                    <p className="my-8 text-xl font-bold">
                        Upload Details
                    </p>
                    <div className="flex flex-wrap space-y-4 lg:space-y-0 justify-between">
                        <div className="w-full lg:w-5/12">
                            <div className="flex justify-center mx-auto space-x-4">
                                <p className="text-center">
                                    Download MediBuddy format to upload Employee
                                    Data
                                </p>
                            </div>
                            <div className="flex justify-center mx-auto space-x-4">
                                <a
                                    href={config.downloadFileUrl}
                                    download="LaunchPad Template.xlsx"
                                    className="btn-secondary border-2 mt-2 w-full h-14 text-center"
                                >
                                    {" "}
                                    Click here to Download
                                </a>
                            </div>
                        </div>
                        <div className="w-full lg:w-5/12">
                            <div className="flex justify-center mx-auto space-x-4">
                                <p>
                                    Upload Employee Excel Sheet
                                </p>
                            </div>
                            <div className="flex justify-center flex-col mx-auto space-x-4">
                                <button
                                    onClick={() => fileUpload.current.click()}
                                    className="btn-secondary border-2 w-full h-14 mt-1.5"
                                >
                                    Click here to Choose File
                                </button>
                                {fileName && (
                                    <p className="text-center mt-2">
                                        Selected File is: {fileName}
                                    </p>
                                )}
                                <input
                                    className="hidden"
                                    type="file"
                                    accept=".xls,.xlsx,.csv"
                                    ref={fileUpload}
                                    onChange={(e) => {
                                        setFile(e.target.files);
                                        setFileName(e.target.files[0].name);
                                        setSteps(3)
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {steps >=3 && 
            <div className="mx-12 mb-10">
                <p className="text-xl font-bold">
                        Make Payment
                </p>
                <div className="flex justify-end space-x-4">
                    <input
                        className="btn-primary shadow-lg mt-10 px-10"
                        type="submit"
                        value="Pay Now"
                        onClick={onFormSubmit}
                    />
                </div>
            </div>
            }
        </div>
    );
}
